import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { forwardRef, useState } from "react";
import DateRangePickersDay from "./DateRangePickersDay";

const getMaxStartDate = (startDate, endDate, maxRangeMonths) => {
  if (!maxRangeMonths) {
    return startDate;
  }
  const maxStartDate = endDate.subtract(maxRangeMonths, "month");
  return maxStartDate.isAfter(startDate) ? maxStartDate : startDate;
};

const DateRangeCalendar = forwardRef((props, ref) => {
  const [startDate, setStartDate] = useState(props.startDate);
  const [endDate, setEndDate] = useState(props.endDate);
  const [hoveredDay, setHoveredDay] = useState(null);

  const onChange = (value) => {
    if (!startDate || value.isBefore(startDate) || (startDate && endDate)) {
      setStartDate(value);
      setEndDate(null);
    } else {
      setEndDate(value);

      const maxStartDate = getMaxStartDate(
        startDate,
        value,
        props.maxRangeMonths,
      );

      if (props.onChange) {
        props.onChange({ startDate: maxStartDate, endDate: value });
      }
    }
  };

  return (
    <DateCalendar
      value={startDate}
      ref={ref}
      onChange={onChange}
      slots={{ day: DateRangePickersDay }}
      slotProps={{
        day: (ownerState) => {
          return {
            isStartDate: ownerState.day.isSame(startDate),
            isEndDate: ownerState.day.isSame(endDate),
            inRange:
              startDate &&
              endDate &&
              !ownerState.day.isBefore(startDate) &&
              !ownerState.day.isAfter(endDate),
            inHoveredRange:
              startDate &&
              !endDate &&
              hoveredDay &&
              !ownerState.day.isBefore(startDate) &&
              !ownerState.day.isAfter(hoveredDay),
            onPointerEnter: () => setHoveredDay(ownerState.day),
            onPointerLeave: () => setHoveredDay(null),
          };
        },
      }}
    />
  );
});

export default DateRangeCalendar;
